export default {
      id: "nav_pause-usage",
      viewBox: "0 0 12 12",
      url: "../dist/images/" + "sprite.svg#nav_pause-usage",
      toString: function () {
        return this.url;
      }
    }